"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatter;

function formatter(value) {
  if (value && typeof value.toString === 'function') {
    return value.toString('dd.mm.yyyy');
  } else {
    return value;
  }
}